import axios from 'axios'
// import adminApi from './admin.js'

// const baseUrl = import.meta.env.VITE_API_SERVER || import.meta.env.BASE_URL
const baseUrl = `${window.location.origin}/api`
console.debug(`API: ${baseUrl}`)

const req = axios.create({ withCredentials: true, baseURL: baseUrl })

const api = {
  connectionStatus: null,

  connectionCallbacks: [],

  updateConnectionStatus(newStatus /*, response, error*/) {
    if (this.connectionStatus != newStatus) {
      this.connectionStatus = newStatus
      this.connectionCallbacks.forEach((fn) => fn(newStatus))
    }
  },

  assignments: {
    async create(form) {
      console.log(`API: assignments.create()`, form)
      // form: { lockerNumber, reservationKey, location?, lockSerial? }
      return req.post(`/assignments`, form).then((response) => response.data)
    },

    async list(eventKey, state = null) {
      console.log(`API: assignments.list(${eventKey}, ${state})`)
      const params = { event: eventKey }
      if (state) params.state = state
      return req.get(`/assignments`, { params }).then((response) => response.data)
    },

    async get(assignmentKey) {
      console.log(`API: assignments.get(${assignmentKey})`)
      return req.get(`/assignments/${assignmentKey}`).then((response) => response.data)
    },

    async release(assignmentKey) {
      console.log(`API: assignments.release(${assignmentKey})`)
      return req.patch(`/assignments/${assignmentKey}/release`).then((response) => response.data)
    },

    async cancel(assignmentKey, reason = null) {
      console.log(`API: assignments.cancel(${assignmentKey})`)
      return req
        .patch(`/assignments/${assignmentKey}/cancel`, { reason })
        .then((response) => response.data)
    },
  },

  vendors: {
    async get(key) {
      console.log(`API: vendors.get(${key})`)
      return req.get(`/vendors/${key}`).then((r) => r.data)
    },

    async update(vendorKey, form) {
      console.log(`API: vendors.update(${vendorKey})`, form)
      return req.patch(`/vendors/${vendorKey}`, form).then((r) => r.data)
    },

    async listMessages(vendorKey) {
      console.log(`API: vendors.listMessages(${vendorKey})`)
      return req.get(`/vendors/${vendorKey}/messages`).then((r) => r.data)
    },

    async listEventMaps(vendorKey) {
      console.log(`API: vendors.listEventMaps(${vendorKey})`)
      return req.get(`/vendors/${vendorKey}/event-maps`).then((r) => r.data)
    },

    async listWorkers(vendorKey) {
      console.log(`API: vendors.listWorkers(${vendorKey})`)
      return req.get(`/vendors/${vendorKey}/workers`).then((r) => r.data)
    },

    async assignAdmin(vendorKey, payload) {
      console.log(`API: vendors.assignAdmin(${vendorKey})`)
      return req.post(`/vendors/${vendorKey}/workers`, payload).then((r) => r.data)
    },

    async listLocks(vendorKey) {
      console.log(`API: vendors.listLocks(${vendorKey})`)
      return req.get(`/vendors/${vendorKey}/locks`).then((r) => r.data)
    },

    async updateLock(vendorKey, lockKey, form) {
      console.log(`API: vendors.updateLock(${vendorKey}, ${lockKey})`)
      return req.patch(`/vendors/${vendorKey}/locks/${lockKey}`, form).then((r) => r.data)
    },

    lockerBanks: {
      async create(vendorKey, form) {
        console.log(`API: vendors.lockerBanks.create(${vendorKey})`, form)
        return req.post(`/vendors/${vendorKey}/locker-banks`, form).then((r) => r.data)
      },

      async get(vendorKey, bankId) {
        console.log(`API: vendors.lockerBanks.get(${vendorKey}, ${bankId})`)
        return req.get(`/vendors/${vendorKey}/locker-banks/${bankId}`).then((r) => r.data)
      },

      async list(vendorKey) {
        console.log(`API: vendors.lockerBanks.list(${vendorKey})`)
        return req.get(`/vendors/${vendorKey}/locker-banks`).then((r) => r.data)
      },

      async updateSlots(vendorKey, bankId, slots) {
        console.log(`API: vendors.lockerBanks.updateSlots(${vendorKey}, ${bankId})`)
        return req.put(`/vendors/${vendorKey}/locker-banks/${bankId}/slots`, slots).then(r => r.data)
      },

      async update(vendorKey, bankId, form) {
        console.log(`API: vendors.lockerBanks.update(${vendorKey}, ${bankId})`, form)
        return req.patch(`/vendors/${vendorKey}/locker-banks/${bankId}`, form).then(r => r.data)
      },

      async resolveQR(shortCode) {
        console.log(`API: vendors.lockerBanks.resolveQR(${shortCode})`)
        return req.get(`/vendors/locker-banks/resolve/${shortCode}`).then(r => r.data)
      },

      async rotateCombo(vendorKey, bankId, slotKey, newCombo) {
        console.log(`API: vendors.lockerBanks.rotateCombo(${vendorKey}, ${bankId}, ${slotKey})`)
        return req.post(`/vendors/${vendorKey}/locker-banks/${bankId}/rotate-combo`, {
          slotKey,
          newCombo,
        }).then(r => r.data)
      },
    },

    async stripeConnectStart(vendorKey) {
      console.log(`API: vendors.stripeConnectStart(${vendorKey})`)
      return req.post(`/vendors/${vendorKey}/stripe/connect`).then((r) => r.data)
    },

    async stripeConnectReturn(vendorKey) {
      console.log(`API: vendors.stripeConnectReturn(${vendorKey})`)
      return req.get(`/vendors/${vendorKey}/stripe/return`).then((r) => r.data)
    },

    async updateLiff(vendorKey, updates) {
      console.log(`API: vendors.updateLiff(${vendorKey})`, updates)
      return req.patch(`/vendors/${vendorKey}/liff`, updates).then((r) => r.data)
    },

    async getCommDefaults(vendorKey) {
      console.log(`API: vendors.getCommDefaults(${vendorKey})`)
      return req.get(`/vendors/${vendorKey}/comm-defaults`).then((r) => r.data)
    },

    async updateCommDefaults(vendorKey, commDefaults) {
      console.log(`API: vendors.updateCommDefaults(${vendorKey})`, commDefaults)
      return req.patch(`/vendors/${vendorKey}/comm-defaults`, commDefaults).then((r) => r.data)
    },

    async listReaders(vendorKey) {
      return req.get(`/vendors/${vendorKey}/readers`).then((r) => r.data)
    },

    async resetAssets(vendorKey) {
      console.log(`API: vendors.resetAssets(${vendorKey})`)
      return req.post(`/vendors/${vendorKey}/reset-assets`).then((r) => r.data)
    },

    async verifySender(vendorKey, form) {
      console.log(`API: vendors.verifySender(${vendorKey})`, form)
      return req.post(`/vendors/${vendorKey}/verify-sender`, form).then((r) => r.data)
    },

    async getSenderStatus(vendorKey) {
      console.log(`API: vendors.getSenderStatus(${vendorKey})`)
      return req.get(`/vendors/${vendorKey}/sender-status`).then((r) => r.data)
    },

    async removeSender(vendorKey) {
      console.log(`API: vendors.removeSender(${vendorKey})`)
      return req.delete(`/vendors/${vendorKey}/verified-sender`).then((r) => r.data)
    },
  },

  admin: {
    vendors: {
      async create(form) {
        console.log('API: admin.vendors.create()')
        return req.post(`/admin/vendors`, form).then((r) => r.data)
      },
      async list() {
        console.log('API: admin.vendors.list()')
        return req.get(`/admin/vendors`).then((r) => r.data)
      },
    },

    readers: {
      async list() {
        return req.get('/admin/readers').then((r) => r.data)
      },

      async add(form) {
        return req.post('/admin/readers', form).then((r) => r.data)
      },

      async update(readerKey, form) {
        return req.patch(`/admin/readers/${readerKey}`, form).then((r) => r.data)
      },

      async assign(readerKey, form) {
        return req.post(`/admin/readers/${readerKey}/assign`, form).then((r) => r.data)
      },

      async release(readerKey) {
        return req.post(`/admin/readers/${readerKey}/release`).then((r) => r.data)
      },

      async retire(readerKey) {
        return req.post(`/admin/readers/${readerKey}/retire`).then((r) => r.data)
      },
    },
  },

  inbox: {
    async markRead(messageKey, read = true) {
      console.log(`API: inbox.markRead(${messageKey}, ${read})`)
      return req.patch(`/messages/${messageKey}`, { read }).then((r) => r.data)
    },

    async reply(messageKey, form) {
      console.log(`API: inbox.reply(${messageKey})`)
      return req.post(`/messages/${messageKey}/reply`, form).then((r) => r.data)
    },
  },

  conversations: {
    async list(vendorKey) {
      console.log(`API: conversations.list(${vendorKey})`)
      return req.get(`/conversations/vendor/${vendorKey}`).then((r) => r.data)
    },

    async get(convKey) {
      console.log(`API: conversations.get(${convKey})`)
      return req.get(`/conversations/${convKey}`).then((r) => r.data)
    },

    async updateStatus(convKey, status) {
      console.log(`API: conversations.updateStatus(${convKey}, ${status})`)
      return req.patch(`/conversations/${convKey}`, { status }).then((r) => r.data)
    },

    async reply(convKey, form) {
      console.log(`API: conversations.reply(${convKey})`)
      return req.post(`/conversations/${convKey}/reply`, form).then((r) => r.data)
    },

    async getUnreadCount(vendorKey) {
      console.log(`API: conversations.getUnreadCount(${vendorKey})`)
      return req.get(`/conversations/vendor/${vendorKey}/unread-count`).then((r) => r.data)
    },
  },

  workers: {
    async list(eventKey) {
      console.log(`API: workers.list(${eventKey})`)
      return req.get(`/workers?event=${eventKey}`).then((r) => r.data)
    },

    async invite(form) {
      console.log('API: workers.invite()', form)
      // form: { vendorKey, email, name, role, eventKey? }
      return req.post(`/workers/invite`, form).then((r) => r.data)
    },

    async getInvitation(token) {
      console.log('API: workers.getInvitation()', token)
      return req.get(`/workers/invitations/${token}`).then((r) => r.data)
    },

    async inviteAccept(token) {
      console.log('API: workers.inviteAccept()', token)
      return req.post(`/workers/invitations/${token}/accept`).then((r) => r.data)
    },

    async inviteEstablish(token, form) {
      console.log('API: workers.inviteEstablish()', token, form)
      // form: { email, name, password }
      return req.post(`/workers/invitations/${token}/establish`, form).then((r) => r.data)
    },

    async listInvitations(params = {}) {
      console.log('API: workers.listInvitations()', params)
      return req
        .get(`/workers/invitations`, {
          params: params,
        })
        .then((r) => r.data)
    },

    async resendInvitation(inviteId) {
      console.log('API: workers.resendInvitation()', inviteId)
      return req.post(`/workers/invitations/resend/${inviteId}`).then((r) => r.data)
    },

    async cancelInvitation(inviteId) {
      console.log('API: workers.cancelInvitation()', inviteId)
      return req.delete(`/workers/invitations/${inviteId}`).then((r) => r.data)
    },

    async getSelf(refresh = false, mode = 'worker') {
      console.log(`API: workers.getSelf(refresh=${refresh}, mode=${mode})`)
      const params = {}
      if (refresh) params.refresh = true
      if (mode) params.mode = mode
      return req.get(`/workers/current`, { params }).then((r) => r.data)
    },

    async editWorker(userKey, vendorKey, form) {
      console.log(`API: workers.editWorker(${userKey})`, form)
      return req.patch(`/workers/${userKey}?vendor=${vendorKey}`, form).then((r) => r.data)
    },

    async removeAccess(userKey, vendorKey, eventKey = null) {
      console.log(`API: workers.removeAccess(${userKey})`)
      const params = { vendor: vendorKey }
      if (eventKey) params.event = eventKey
      return req.delete(`/workers/${userKey}/access`, { params }).then((r) => r.data)
    },
  },

  events: {
    async lockerBankAdd(eventKey, form) {
      console.log(`API: events.lockerBankAdd(${eventKey})`)
      return req.post(`/events/${eventKey}/lockers`, form).then((response) => response.data)
    },

    async lockerBanksList(eventKey) {
      console.log(`API: events.lockerBanksList(${eventKey})`)
      return req.get(`/events/${eventKey}/lockers`).then((response) => response.data)
    },

    async locksList(eventKey, state = null, location = null) {
      console.log(`API: events.locksList(${eventKey}, ${state}, ${location})`)
      const params = {}
      if (state) params.state = state
      if (location) params.location = location
      return req
        .get(`/events/${eventKey}/locks`, { params: params })
        .then((response) => response.data)
    },

    async lockersList(eventKey, location = null) {
      console.log(`API: events.lockersList(${eventKey}, ${location})`)
      const params = {}
      if (location) params.location = location
      return req
        .get(`/events/${eventKey}/lockers`, { params: params })
        .then((response) => response.data)
    },

    async reserveADA(eventKey, lockerKeys) {
      console.log(`API: events.reserveADA(${eventKey})`, lockerKeys.length, 'lockers')
      return req
        .post(`/events/${eventKey}/lockers/reserve-ada`, { lockerKeys })
        .then((response) => response.data)
    },

    async unreserveADA(eventKey, lockerKeys) {
      console.log(`API: events.unreserveADA(${eventKey})`, lockerKeys.length, 'lockers')
      return req
        .post(`/events/${eventKey}/lockers/unreserve-ada`, { lockerKeys })
        .then((response) => response.data)
    },

    async rebuildCache(eventKey) {
      console.log(`API: events.rebuildCache(${eventKey})`)
      return req.post(`/events/${eventKey}/rebuild-cache`).then((response) => response.data)
    },

    async create(form) {
      console.log(`API: events.create()`)
      return req.post(`/events`, form).then((response) => response.data)
    },

    async list(vendorKey) {
      console.log(`API: events.list(${vendorKey})`)
      return req.get(`/events?vendor=${vendorKey}`).then((response) => response.data)
    },

    async get(eventKey, vendorSlug = null) {
      console.log(`API: events.get(${eventKey}, vendor=${vendorSlug})`)
      const params = vendorSlug ? { vendor: vendorSlug } : {}
      return req.get(`/events/${eventKey}`, { params }).then((response) => response.data)
    },

    async update(eventKey, form) {
      console.log(`API: events.update(${eventKey})`, form)
      return req.patch(`/events/${eventKey}`, form).then((response) => response.data)
    },

    async listLocations(eventKey) {
      console.log(`API: events.listLocations(${eventKey})`)
      return req.get(`/events/${eventKey}/locations`).then((response) => response.data)
    },

    async createLocation(eventKey, form) {
      console.log(`API: events.createLocation(${eventKey})`, form)
      return req.post(`/events/${eventKey}/locations`, form).then((response) => response.data)
    },

    async updateLocation(eventKey, locationId, form) {
      console.log(`API: events.updateLocation(${eventKey}, ${locationId})`, form)
      return req
        .patch(`/events/${eventKey}/locations/${locationId}`, form)
        .then((response) => response.data)
    },

    async deleteLocation(eventKey, locationId) {
      console.log(`API: events.deleteLocation(${eventKey}, ${locationId})`)
      return req
        .delete(`/events/${eventKey}/locations/${locationId}`)
        .then((response) => response.data)
    },

    // Locker Model Methods

    async listLockerModels(eventKey) {
      console.log(`API: events.listLockerModels(${eventKey})`)
      return req.get(`/events/${eventKey}/locker-models`).then((response) => response.data)
    },

    async createLockerModel(eventKey, form) {
      console.log(`API: events.createLockerModel(${eventKey})`)
      return req.post(`/events/${eventKey}/locker-models`, form).then((response) => response.data)
    },

    async updateLockerModel(eventKey, modelId, form) {
      console.log(`API: events.updateLockerModel(${eventKey}, ${modelId})`)
      return req
        .patch(`/events/${eventKey}/locker-models/${modelId}`, form)
        .then((response) => response.data)
    },

    async deleteLockerModel(eventKey, modelId) {
      console.log(`API: events.deleteLockerModel(${eventKey}, ${modelId})`)
      return req
        .delete(`/events/${eventKey}/locker-models/${modelId}`)
        .then((response) => response.data)
    },

    // Locker Map Methods

    async mapCreate(eventKey, form) {
      console.log(`API: events.mapCreate(${eventKey})`)
      return req.post(`/events/${eventKey}/maps`, form).then((response) => response.data)
    },

    async mapList(eventKey) {
      console.log(`API: events.mapList(${eventKey})`)
      return req.get(`/events/${eventKey}/maps`).then((response) => response.data)
    },

    async mapGet(eventKey, mapId) {
      console.log(`API: events.mapGet(${eventKey}, ${mapId})`)
      return req.get(`/events/${eventKey}/maps/${mapId}`).then((response) => response.data)
    },

    async mapUpdate(eventKey, mapId, form) {
      console.log(`API: events.mapUpdate(${eventKey}, ${mapId})`)
      return req.patch(`/events/${eventKey}/maps/${mapId}`, form).then((response) => response.data)
    },

    async mapDelete(eventKey, mapId) {
      console.log(`API: events.mapDelete(${eventKey}, ${mapId})`)
      return req.delete(`/events/${eventKey}/maps/${mapId}`).then((response) => response.data)
    },

    async resetMapSetup(eventKey, mapId) {
      console.log(`API: events.resetMapSetup(${eventKey}, ${mapId})`)
      return req
        .post(`/events/${eventKey}/maps/${mapId}/reset-setup`)
        .then((response) => response.data)
    },

    async mapExport(eventKey, mapId) {
      console.log(`API: events.mapExport(${eventKey}, ${mapId})`)
      const response = await this.mapGet(eventKey, mapId)
      const blob = new Blob([JSON.stringify(response.map, null, 2)], { type: 'application/json' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${response.map.name.replace(/\s+/g, '-')}-${mapId}.json`
      a.click()
      URL.revokeObjectURL(url)
    },

    async mapCompleteSetup(eventKey, mapId) {
      console.log(`API: events.mapCompleteSetup(${eventKey}, ${mapId})`)
      return req
        .post(`/events/${eventKey}/maps/${mapId}/complete-setup`)
        .then((response) => response.data)
    },

    async mapUpdateStepStatus(eventKey, mapId, form) {
      console.log(`API: events.mapUpdateStepStatus(${eventKey}, ${mapId})`, form)
      return req
        .post(`/events/${eventKey}/maps/${mapId}/step-status`, form)
        .then((response) => response.data)
    },

    async scanBank(eventKey, mapId, form) {
      console.log(`API: events.scanBank(${eventKey}, ${mapId})`, form)
      return req
        .post(`/events/${eventKey}/maps/${mapId}/scan-bank`, form)
        .then((response) => response.data)
    },

    async removeBank(eventKey, mapId, bankId, collapse = false) {
      console.log(`API: events.removeBank(${eventKey}, ${mapId}, ${bankId}, collapse=${collapse})`)
      return req
        .delete(`/events/${eventKey}/maps/${mapId}/banks/${encodeURIComponent(bankId)}`, {
          params: { collapse },
        })
        .then((response) => response.data)
    },

    async generateProductsFromMap(eventKey, mapId) {
      console.log(`API: events.generateProductsFromMap(${eventKey}, ${mapId})`)
      return req
        .post(`/events/${eventKey}/maps/${mapId}/generate-products`)
        .then((response) => response.data)
    },

    async mapCapacitySummary(eventKey) {
      console.log(`API: events.mapCapacitySummary(${eventKey})`)
      return req
        .get(`/events/${eventKey}/map-capacity-summary`)
        .then((response) => response.data)
    },

    // Product Methods

    async listProducts(eventKey) {
      console.log(`API: events.listProducts(${eventKey})`)
      return req.get(`/events/${eventKey}/products`).then((response) => response.data)
    },

    async createProduct(eventKey, form) {
      console.log(`API: events.createProduct(${eventKey})`, form)
      return req.post(`/events/${eventKey}/products`, form).then((response) => response.data)
    },

    async updateProduct(eventKey, productId, form) {
      console.log(`API: events.updateProduct(${eventKey}, ${productId})`, form)
      return req
        .patch(`/events/${eventKey}/products/${productId}`, form)
        .then((response) => response.data)
    },

    async deleteProduct(eventKey, productId) {
      console.log(`API: events.deleteProduct(${eventKey}, ${productId})`)
      return req
        .delete(`/events/${eventKey}/products/${productId}`)
        .then((response) => response.data)
    },

    async publishProducts(eventKey) {
      console.log(`API: events.publishProducts(${eventKey})`)
      return req
        .post(`/events/${eventKey}/products/publish`)
        .then((response) => response.data)
    },

    async reorderProducts(eventKey, productKeys) {
      console.log(`API: events.reorderProducts(${eventKey})`, productKeys.length, 'products')
      return req
        .put(`/events/${eventKey}/products/reorder`, { productKeys })
        .then((response) => response.data)
    },

    async regenerateProducts(eventKey, mapId) {
      console.log(`API: events.regenerateProducts(${eventKey}, ${mapId})`)
      return req
        .post(`/events/${eventKey}/maps/${mapId}/regenerate-products`)
        .then((response) => response.data)
    },

    async transitionState(eventKey, state) {
      console.log(`API: events.transitionState(${eventKey}, ${state})`)
      return req
        .post(`/events/${eventKey}/transition`, { state })
        .then((response) => response.data)
    },

    async getCommSettings(eventKey) {
      console.log(`API: events.getCommSettings(${eventKey})`)
      return req.get(`/events/${eventKey}/settings/communication`).then((response) => response.data)
    },

    async updateCommSettings(eventKey, form) {
      console.log(`API: events.updateCommSettings(${eventKey})`, form)
      return req
        .patch(`/events/${eventKey}/settings/communication`, form)
        .then((response) => response.data)
    },

    async flushHeldEmails(eventKey) {
      console.log(`API: events.flushHeldEmails(${eventKey})`)
      return req
        .post(`/events/${eventKey}/flush-emails`)
        .then((response) => response.data)
    },

    // Email Insights Methods

    async getEmailInsights(eventKey) {
      console.log(`API: events.getEmailInsights(${eventKey})`)
      return req.get(`/events/${eventKey}/email-insights`).then((r) => r.data)
    },

    async fixBouncedEmail(eventKey, form) {
      console.log(`API: events.fixBouncedEmail(${eventKey})`, form)
      return req.post(`/events/${eventKey}/email-insights/fix`, form).then((r) => r.data)
    },

    async dismissBouncedEmail(eventKey, form) {
      console.log(`API: events.dismissBouncedEmail(${eventKey})`, form)
      return req.post(`/events/${eventKey}/email-insights/dismiss`, form).then((r) => r.data)
    },

    async undismissBouncedEmail(eventKey, form) {
      console.log(`API: events.undismissBouncedEmail(${eventKey})`, form)
      return req.post(`/events/${eventKey}/email-insights/undismiss`, form).then((r) => r.data)
    },

    async updateVenueAddress(eventKey, address) {
      console.log(`API: events.updateVenueAddress(${eventKey})`, address)
      return req
        .patch(`/events/${eventKey}/venue-address`, address)
        .then((response) => response.data)
    },

    async getTaxStatus(eventKey) {
      console.log(`API: events.getTaxStatus(${eventKey})`)
      return req
        .get(`/events/${eventKey}/tax-status`)
        .then((response) => response.data)
    },

    async pauseProduct(eventKey, productId) {
      console.log(`API: events.pauseProduct(${eventKey}, ${productId})`)
      return req.post(`/events/${eventKey}/products/${productId}/pause`).then((r) => r.data)
    },

    async unpauseProduct(eventKey, productId) {
      console.log(`API: events.unpauseProduct(${eventKey}, ${productId})`)
      return req.post(`/events/${eventKey}/products/${productId}/unpause`).then((r) => r.data)
    },

    async pauseAllProducts(eventKey) {
      console.log(`API: events.pauseAllProducts(${eventKey})`)
      return req.post(`/events/${eventKey}/products/pause-all`).then((r) => r.data)
    },

    async unpauseAllProducts(eventKey) {
      console.log(`API: events.unpauseAllProducts(${eventKey})`)
      return req.post(`/events/${eventKey}/products/unpause-all`).then((r) => r.data)
    },

    async goLive(eventKey) {
      console.log(`API: events.goLive(${eventKey})`)
      return req.post(`/events/${eventKey}/go-live`).then((r) => r.data)
    },

    async generatePreviewToken(eventKey) {
      console.log(`API: events.generatePreviewToken(${eventKey})`)
      return req.post(`/events/${eventKey}/preview-token`).then((r) => r.data)
    },

    async updateTaxMode(eventKey, form) {
      console.log(`API: events.updateTaxMode(${eventKey})`, form)
      return req.patch(`/events/${eventKey}/tax-mode`, form).then((r) => r.data)
    },

    async exportOrdersCsv(eventKey) {
      console.log(`API: events.exportOrdersCsv(${eventKey})`)
      return req.get(`/events/${eventKey}/orders/export`, { responseType: 'blob' }).then((r) => r.data)
    },

    async getTaxReport(eventKey) {
      console.log(`API: events.getTaxReport(${eventKey})`)
      return req.get(`/events/${eventKey}/tax-report`).then((r) => r.data)
    },

    async downloadTaxReportPdf(eventKey) {
      console.log(`API: events.downloadTaxReportPdf(${eventKey})`)
      return req.get(`/events/${eventKey}/tax-report/pdf`, { responseType: 'blob' }).then((r) => r.data)
    },

    async recalculateInventory(eventKey, dryRun = false) {
      console.log(`API: events.recalculateInventory(${eventKey}, dryRun=${dryRun})`)
      return req
        .post(`/events/${eventKey}/products/recalculate-inventory`, null, {
          params: { dry_run: dryRun },
        })
        .then((r) => r.data)
    },

    async recalculateProductInventory(eventKey, productId, dryRun = false) {
      console.log(`API: events.recalculateProductInventory(${eventKey}, ${productId}, dryRun=${dryRun})`)
      return req
        .post(`/events/${eventKey}/products/${productId}/recalculate-inventory`, null, {
          params: { dry_run: dryRun },
        })
        .then((r) => r.data)
    },

    async closeEvent(eventKey) {
      console.log(`API: events.closeEvent(${eventKey})`)
      return req.post(`/events/${eventKey}/close`).then((r) => r.data)
    },

    async cloneEvent(eventKey, form) {
      console.log(`API: events.cloneEvent(${eventKey})`, form)
      return req.post(`/events/${eventKey}/clone`, form).then((r) => r.data)
    },


    async resetReservations(eventKey) {
      console.log(`API: events.resetReservations(${eventKey})`)
      return req.post(`/events/${eventKey}/reset-reservations`).then((r) => r.data)
    },
  },

  locks: {
    async create(form) {
      console.log(`API: locks.create()`)
      return req.post(`/locks`, form).then((response) => response.data)
    },

    async import(form) {
      console.log(`API: locks.import()`)
      // this is bulk upload via csv
      return req.post(`/locks/import`, form).then((response) => response.data)
    },

    async list(orgKey, variant) {
      console.log(`API: locks.list(${orgKey}, ${variant})`)
      // add variant query param
      return req.get(`/locks?org=${orgKey}&variant=${variant}`).then((response) => response.data)
    },

    async listByEvent(eventKey, filters = {}) {
      console.log(`API: locks.listByEvent(${eventKey})`, filters)
      const params = {}
      if (filters.state) params.state = filters.state
      if (filters.location) params.location = filters.location
      return req.get(`/events/${eventKey}/locks`, { params }).then((response) => response.data)
    },

    async get(lockKey) {
      console.log(`API: locks.get(${lockKey})`)
      return req.get(`/locks/${lockKey}`).then((response) => response.data)
    },
  },

  lockers: {
    async assignLock(eventKey, lockerKey, form) {
      console.log(`API: lockers.assignLock(${eventKey}, ${lockerKey})`, form)
      return req
        .post(`/events/${eventKey}/lockers/${lockerKey}/assign-lock`, form)
        .then((response) => response.data)
    },

    async assignLocksBatch(eventKey, assignments) {
      console.log(`API: lockers.assignLocksBatch(${eventKey})`, assignments.length, 'assignments')
      return req
        .post(`/events/${eventKey}/lockers/assign-locks-batch`, assignments)
        .then((response) => response.data)
    },

    async listAvailable(eventKey, { location, size, isAda } = {}) {

      const params = {}
      if (location) params.location = location
      if (size) params.size = size
      if (isAda) params.isAda = true
      return req
        .get(`/events/${eventKey}/lockers/available`, { params })
        .then((response) => response.data)
    },
  },

  reservations: {
    async assign(reservationKey, form) {
      console.log(`API: reservations.assign(${reservationKey})`, form)
      return req
        .post(`/reservations/${reservationKey}/assign`, form)
        .then((response) => response.data)
    },

    async cancel(reservationKey, form) {
      console.log(`API: reservations.cancel(${reservationKey})`, form)
      return req
        .post(`/reservations/${reservationKey}/cancel`, form)
        .then((response) => response.data)
    },

    async create(form) {
      console.log(`API: reservations.create()`)
      // this would be an in person purchase
      return req.post(`/reservations`, form).then((response) => response.data)
    },

    async get(reservationKey) {
      console.log(`API: reservations.get(${reservationKey})`)
      return req.get(`/reservations/${reservationKey}`).then((response) => response.data)
    },

    async update(reservationKey, form) {
      console.log(`API: reservations.update(${reservationKey})`, form)
      return req.patch(`/reservations/${reservationKey}`, form).then((response) => response.data)
    },

    async import(form) {
      console.log(`API: reservations.import()`)
      // this is bulk upload via csv
      return req.post(`/reservations/import`, form).then((response) => response.data)
    },

    async list(eventKey) {
      console.log(`API: reservations.list(${eventKey})`)
      return req.get(`/reservations?event=${eventKey}`).then((response) => response.data)
    },

    async release(reservationKey, form) {
      console.log(`API: reservations.release(${reservationKey})`, form)
      return req
        .post(`/reservations/${reservationKey}/release`, form)
        .then((response) => response.data)
    },

    async swapLock(reservationKey, form) {
      console.log(`API: reservations.swapLock(${reservationKey})`, form)
      return req
        .put(`/reservations/${reservationKey}/swap-lock`, form)
        .then((response) => response.data)
    },

    async switchLocker(reservationKey, form) {
      console.log(`API: reservations.switchLocker(${reservationKey})`, form)
      return req
        .put(`/reservations/${reservationKey}/switch-locker`, form)
        .then((response) => response.data)
    },

    async resendAssignmentMessage(reservationKey) {
      console.log(`API: reservations.resendAssignmentMessage(${reservationKey})`)

      return req
        .post(`/reservations/${reservationKey}/message/assign`)
        .then((response) => response.data)
    },

    async findByLock(eventKey, lockKey) {
      console.log(`API: reservations.findByLock(${eventKey}, ${lockKey})`)
      return req
        .get(`/events/${eventKey}/reservations/find-by-lock`, {
          params: { lockKey },
        })
        .then((response) => response.data)
    },

    async getMessages(reservationKey) {
      console.log(`API: reservations.getMessages(${reservationKey})`)

      return req.get(`/reservations/${reservationKey}/messages`).then((response) => response.data)
    },

  },

  orders: {
    async get(orderKey) {
      console.log(`API: orders.get(${orderKey})`)
      return req.get(`/orders/${orderKey}`).then((r) => r.data)
    },

    async refund(orderKey, reason = null) {
      console.log(`API: orders.refund(${orderKey})`)
      const body = reason ? { reason } : {}
      return req.post(`/orders/${orderKey}/refund`, body).then((r) => r.data)
    },

    async listReservations(orderKey) {
      return req.get(`/orders/${orderKey}/reservations`).then((r) => r.data)
    },
  },

  async getCurrentWorker(mode = 'user') {
    console.log(`API: getCurrentWorker(${mode})`)
    // mode = user, full
    let params = { mode }

    return req.get(`/workers/current`, { params: params }).then((response) => response.data)
  },

  // Alias for convenience
  locations: {
    async list(eventKey) {
      console.log(`API: locations.list(${eventKey})`)
      return api.events.listLocations(eventKey)
    },
  },


  turnover: {
    async getLockers(eventId, location, period = null, simulateDate = null) {
      console.log(`API: turnover.getLockers(${eventId}, ${location}, ${period})`)
      const params = new URLSearchParams({ location })
      if (period) params.append('period', period)
      if (simulateDate) params.append('simulateDate', simulateDate)
      return req.get(`/events/${eventId}/lockers/turnover?${params}`).then((r) => r.data)
    },

    async start(lockerKey) {
      console.log(`API: turnover.start(${lockerKey})`)
      return req.post(`/lockers/${lockerKey}/turnover/start`).then((r) => r.data)
    },

    async complete(lockerKey, form) {
      console.log(`API: turnover.complete(${lockerKey})`, form)
      return req.post(`/lockers/${lockerKey}/turnover/complete`, form).then((r) => r.data)
    },

    async unassignLock(lockKey, form) {
      console.log(`API: turnover.unassignLock(${lockKey})`, form)
      return req.post(`/locks/${lockKey}/unassign`, form).then((r) => r.data)
    },

    async lookupLock(eventId, lockNumber) {
      console.log(`API: turnover.lookupLock(${eventId}, ${lockNumber})`)
      return req.get(`/events/${eventId}/locks/lookup/${lockNumber}`).then((r) => r.data)
    },

    async uploadBelongingsPhoto(resKey, photoFile) {
      console.log(`API: turnover.uploadBelongingsPhoto(${resKey})`)
      const formData = new FormData()
      formData.append('photo', photoFile)
      return req
        .post(`/reservations/${resKey}/belongings/photo`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((r) => r.data)
    },

    async getBelongingsPhotoUrl(resKey) {
      console.log(`API: turnover.getBelongingsPhotoUrl(${resKey})`)
      return req.get(`/reservations/${resKey}/belongings/photo`).then((r) => r.data)
    },

    async listLeftoverItems(eventId, location = null, status = null) {
      console.log(`API: turnover.listLeftoverItems(${eventId}, ${location}, ${status})`)
      const params = new URLSearchParams()
      if (location) params.append('location', location)
      if (status) params.append('status', status)
      return req.get(`/events/${eventId}/reservations/leftover-items?${params}`).then((r) => r.data)
    },

    async updateBelongingsStatus(reservationKey, form) {
      console.log(`API: turnover.updateBelongingsStatus(${reservationKey})`, form)
      return req.patch(`/reservations/${reservationKey}/belongings`, form).then((r) => r.data)
    },
  },

  deploy: {
    async listProjects() {
      console.log('API: deploy.listProjects()')
      return req.get('/deploy/projects').then((r) => r.data)
    },

    async getStatus(projectId) {
      console.log(`API: deploy.getStatus(${projectId})`)
      return req.get(`/deploy/projects/${projectId}/status`).then((r) => r.data)
    },

    async getCommits(projectId, page = 1, perPage = 20, branch = null) {
      console.log(`API: deploy.getCommits(${projectId}, page=${page}, branch=${branch})`)
      const params = { page, per_page: perPage }
      if (branch) params.branch = branch
      return req.get(`/deploy/projects/${projectId}/commits`, { params }).then((r) => r.data)
    },

    async listBranches(projectId) {
      console.log(`API: deploy.listBranches(${projectId})`)
      return req.get(`/deploy/projects/${projectId}/branches`).then((r) => r.data)
    },

    async deployToProduction(projectId, branch = 'main') {
      console.log(`API: deploy.deployToProduction(${projectId}, branch=${branch})`)
      return req.post(`/deploy/projects/${projectId}/deploy`, null, { params: { branch } }).then((r) => r.data)
    },

    async deployToDev(projectId, branch = 'develop') {
      console.log(`API: deploy.deployToDev(${projectId}, branch=${branch})`)
      return req.post(`/deploy/projects/${projectId}/deploy-dev`, null, { params: { branch } }).then((r) => r.data)
    },

    async rollback(projectId) {
      console.log(`API: deploy.rollback(${projectId})`)
      return req.post(`/deploy/projects/${projectId}/rollback`).then((r) => r.data)
    },
  },

  ping() {
    return req.get('/utils/ping').then((response) => response.data)
  },

  sales: {
    async listProducts(eventKey) {
      console.log(`API: sales.listProducts(${eventKey})`)
      return req.get(`/events/${eventKey}/sales/products`).then((r) => r.data)
    },

    async listRecent(eventKey, limit = 25) {

      return req
        .get(`/events/${eventKey}/sales/recent`, { params: { limit } })
        .then((r) => r.data)
    },

    async listReaders(eventKey) {
      console.log(`API: sales.listReaders(${eventKey})`)
      return req.get(`/events/${eventKey}/readers`).then((r) => r.data)
    },

    async createOrder(eventKey, form) {
      console.log(`API: sales.createOrder(${eventKey})`, form)
      return req.post(`/events/${eventKey}/sales/orders`, form).then((r) => r.data)
    },

    async sendToTerminal(eventKey, orderToken, form) {
      console.log(`API: sales.sendToTerminal(${eventKey}, ${orderToken})`, form)
      return req
        .post(`/events/${eventKey}/sales/orders/${orderToken}/send-to-terminal`, form)
        .then((r) => r.data)
    },

    async getOrderStatus(eventKey, orderToken) {
      return req
        .get(`/events/${eventKey}/sales/orders/${orderToken}/status`)
        .then((r) => r.data)
    },

    async cancelTerminal(eventKey, orderToken) {
      console.log(`API: sales.cancelTerminal(${eventKey}, ${orderToken})`)
      return req
        .post(`/events/${eventKey}/sales/orders/${orderToken}/cancel`)
        .then((r) => r.data)
    },

    async assignLocker(eventKey, orderToken, form) {
      console.log(`API: sales.assignLocker(${eventKey}, ${orderToken})`, form)
      return req
        .post(`/events/${eventKey}/sales/orders/${orderToken}/assign`, form)
        .then((r) => r.data)
    },

    async autoAssignLocker(eventKey, orderToken, { reservationKey } = {}) {
      const body = {}
      if (reservationKey) body.reservationKey = reservationKey
      return req
        .post(`/events/${eventKey}/sales/orders/${orderToken}/auto-assign`, body)
        .then((r) => r.data)
    },

    async clearReader(eventKey, readerId) {
      console.log(`API: sales.clearReader(${eventKey}, ${readerId})`)
      return req
        .post(`/events/${eventKey}/sales/readers/${readerId}/clear`)
        .then((r) => r.data)
    },
  },

  readers: {
    async listForEvent(eventKey) {
      return req.get(`/events/${eventKey}/readers`).then((r) => r.data)
    },

    async listAvailable(eventKey) {
      return req.get(`/events/${eventKey}/readers/available`).then((r) => r.data)
    },

    async attach(eventKey, readerKey, { registrationCode, locationId } = {}) {
      return req
        .post(`/events/${eventKey}/readers/${readerKey}/attach`, {
          registrationCode,
          locationId: locationId || undefined,
        })
        .then((r) => r.data)
    },

    async detach(eventKey, readerKey) {
      return req.post(`/events/${eventKey}/readers/${readerKey}/detach`).then((r) => r.data)
    },
  },
}

const handleApiError = (error) => {
  // Handle network errors (no response received)
  if (!error.response) {
    if (error.request) {
      api.updateConnectionStatus('offline', null, error)
    } else {
      // Log client-side errors (e.g., request config errors)
      console.debug('API Error:', error.message)
    }
    return Promise.reject(error)
  }

  const { status } = error.response

  // Handle 401 Unauthorized - redirect to login
  if (status === 401 && !location.pathname.startsWith('/login')) {
    const { origin, pathname, hash } = window.location
    const route = hash.startsWith('#/') ? hash.slice(2) : hash
    const app = pathname.replace(/^\/+|\/+$/g, '')

    let redirectPath = '/login'
    if (route) redirectPath += `#${route}`
    if (app) redirectPath += `${route ? '&' : '#'}a=${app}`

    window.location.href = `${origin}${redirectPath}`
    return Promise.reject(new Error('Unauthorized - redirecting to login'))
  }

  // Handle 403 Forbidden - granular handling based on error codes
  if (status === 403) {
    const errorDetail = error.response?.data?.detail || {}
    const errorCode = errorDetail.code || 'FORBIDDEN'

    console.warn(`403 Forbidden - Code: ${errorCode}`, {
      url: error.config?.url,
      detail: errorDetail,
    })

    // Don't trigger access check recursively or on login/no-access pages
    if (
      window._accessCheckInProgress ||
      location.pathname.startsWith('/login') ||
      location.hash.includes('no-access')
    ) {
      return Promise.reject(error)
    }

    // INSUFFICIENT_ROLE: user has vendor access but not this specific permission
    // Let the calling component handle this (show inline error, don't redirect)
    if (errorCode === 'INSUFFICIENT_ROLE') {
      console.info('403 INSUFFICIENT_ROLE - component should handle this error inline')
      return Promise.reject(error)
    }

    // NO_VENDOR_ACCESS or unknown: verify if user still has any access
    window._accessCheckInProgress = true

    api.workers
      .getSelf(true, 'worker')
      .then(({ worker }) => {
        window._accessCheckInProgress = false

        if (!worker.locker_roles?.length) {
          console.warn('Access revoked - no remaining roles')
          window.location.href = '/#/no-access'
        } else {
          // User has roles but tried to access a vendor/event they don't belong to
          // Redirect home so they land on their actual content
          console.info('User has roles elsewhere - redirecting home')
          window.location.href = '/#/'
        }
      })
      .catch(() => {
        window._accessCheckInProgress = false
        console.warn('Could not verify access status - logging out')
        window.location.href = '/logout?reason=session_error'
      })

    // Still reject the original error so the calling code knows it failed
    return Promise.reject(error)
  }

  // For other error responses, reject with the error
  return Promise.reject(error)
}

// Response interceptor
req.interceptors.response.use(
  (response) => {
    api.updateConnectionStatus('online', response)
    return response
  },
  (error) => handleApiError(error)
)

export default api
